import request from '@/router/axios'

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'true' ? '/wage/wagebatchinfo' : '/wage/wagebatchinfo'

// 发票列表
export function queryInvoiceListByPage(data) {
  return request({
    url: urlPrefix + '/queryInvoiceListByPage',
    method: 'post',
    data
  })
}
